import { types } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils/utils';
import { DayOfWeek } from './models';

export const DayOfWeekStore = types
  .compose(
    getBaseStore<typeof DayOfWeek.Type, typeof DayOfWeek.SnapshotType>(DayOfWeek, 'dowId', 'dayOfWeek'),
    types.model('DayOfWeek', {}),
  )
  .views((self) => ({
    getDayOfWeekList() {
      return [
        { dowId: 0, code: null, englishName: ' ', frenchName: 'aucun' },
        { dowId: 1, code: 'MONDAY', englishName: 'monday', frenchName: 'lundi' },
        { dowId: 2, code: 'TUESDAY', englishName: 'tuesday', frenchName: 'mardi' },
        { dowId: 3, code: 'WEDNESDAY', englishName: 'wednesday', frenchName: 'mercredi' },
        { dowId: 4, code: 'THURSDAY', englishName: 'thursday', frenchName: 'jeudi' },
        { dowId: 5, code: 'FRIDAY', englishName: 'friday', frenchName: 'vendredi' },
      ];
    },
    getByCode(code: string) {
      const res = [
        { dowId: 0, code: null, englishName: ' ', frenchName: 'aucun' },
        { dowId: 1, code: 'MONDAY', englishName: 'monday', frenchName: 'lundi' },
        { dowId: 2, code: 'TUESDAY', englishName: 'tuesday', frenchName: 'mardi' },
        { dowId: 3, code: 'WEDNESDAY', englishName: 'wednesday', frenchName: 'mercredi' },
        { dowId: 4, code: 'THURSDAY', englishName: 'thursday', frenchName: 'jeudi' },
        { dowId: 5, code: 'FRIDAY', englishName: 'friday', frenchName: 'vendredi' },
      ].find((dow) => dow.code === code);
      return res;
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);

    return {};
  });

export type DayOfWeekStoreType = typeof DayOfWeekStore;
